import ModalView from './ModalView.container';

export default ModalView;
